import { v4 as uuidv4 } from "uuid";

export type AiCustomInputs = {
    model: "dalle-3";
    size: string;
    num_images: number;
    searchId: number;
    prompt: string;
};

export function getRequestOptions(inputs: AiCustomInputs, refreshCounter = 0) {
    const uuid = `${uuidv4()}-${refreshCounter}`;

    return {
        type: "OPENAI_AZURE_DALLE3",
        input: {
            ...inputs,
            prompt: inputs.prompt ?? "",
            size: inputs.size ?? "1024x1024",
            num_images: inputs.num_images ?? 1,
            uuid
        }
    };
}
